// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { xButtonSharedStyles } from "@werner/App/SharedStyle/Common/ButtonsSharedStyles";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

assignBudgetsStyles.wrapper = {
    css: css`
        display: flex;
        margin: 0 30px 15px 0;
        min-width: 200px;
        max-width: 350px;
        width: 100%:
    `,
};

assignBudgetsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", 500)} {
            width: 100%;
        }
    `,
};

assignBudgetsStyles.enforcementLevelDisplayStyles = {
    labelText: {
        as: "h4",
        variant: "h6",
        css: css`
            display: flex;
        `,
    },
};
assignBudgetsStyles.buttonsGridItem = {
    ...assignBudgetsStyles.buttonsGridItem,
    width: [12, 12, 5, 5, 5],
    css: css`
        ${assignBudgetsStyles.buttonsGridItem?.css}
        gap: 10px;
        ${xScreen("lte", 500)} {
            flex-direction: column-reverse;
        }
    `,
};
assignBudgetsStyles.buttonsHidden = {
    ...assignBudgetsStyles.buttonsHidden,
    css: css`
        ${assignBudgetsStyles.buttonsHidden?.css}
        gap: 10px;
        ${xScreen("lte", 500)} {
            width: 100%;
            flex-direction: column-reverse;
        }
    `,
};

assignBudgetsStyles.saveButton = {
    variant: "primary",
    css: css`
        margin: 0;

        ${xScreen("lte", 500)} {
            width: 100%;
        }
    `,
};

assignBudgetsStyles.titleGridItem = {
    ...assignBudgetsStyles.titleGridItem,
    width: [12, 12, 7, 7, 7],
};

assignBudgetsStyles.tableGridItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        & > div {
                overflow-x: hidden;
        }
    `,
};
